import {
  ACTION_GET_TRANSACTIONS,
  ACTION_GET_TRANSACTIONS_SUCCESS,
  ACTION_GET_TRANSACTIONS_FAILURE,
  ACTION_DISCARD_TRANSACTIONS,
  ACTION_DISCARD_TRANSACTIONS_SUCCESS,
  ACTION_DISCARD_TRANSACTIONS_FAILURE,
  ACTION_RESTORE_TRANSACTIONS,
  ACTION_RESTORE_TRANSACTIONS_SUCCESS,
  ACTION_RESTORE_TRANSACTIONS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export type Params = {
  organizationId?: string;
};

export function getTransactions(organizationId: string, startDate: string = '', endDate: string = '') {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/transactions?startDate=${startDate}&endDate=${endDate}`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(ACTION_GET_TRANSACTIONS_FAILURE, response));
          } else {
            dispatch(requestSuccess(ACTION_GET_TRANSACTIONS_SUCCESS, response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(ACTION_GET_TRANSACTIONS_FAILURE, error));
        },
      },
    });

    return null;
  };
}

export function discardTransactions(organizationId: string, syncedTransactionIds: string[]) {
  const url = `organizations/${organizationId}/transactions/discard`;
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: API_CALL,
      payload: {
        call: url,
        method: 'post',
        data: JSON.stringify({
          id: organizationId,
          syncedTransactionIds,
        }),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(ACTION_DISCARD_TRANSACTIONS_FAILURE, response));
          } else {
            const modifiedResponse = {..._.cloneDeep(response), syncedTransactionIds};
            dispatch(requestSuccess(ACTION_DISCARD_TRANSACTIONS_SUCCESS, response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(ACTION_DISCARD_TRANSACTIONS_FAILURE, error));
        },
      },
    });

    return null;
  };
}

export function restoreTransactions(organizationId: string, syncedTransactionIds: string[]) {
  const url = `organizations/${organizationId}/transactions/restore`;
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: API_CALL,
      payload: {
        call: url,
        method: 'post',
        data: JSON.stringify({
          id: organizationId,
          syncedTransactionIds,
        }),
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(ACTION_RESTORE_TRANSACTIONS_FAILURE, response));
          } else {
            const modifiedResponse = {..._.cloneDeep(response), syncedTransactionIds};
            dispatch(requestSuccess(ACTION_RESTORE_TRANSACTIONS_SUCCESS, modifiedResponse));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(ACTION_RESTORE_TRANSACTIONS_FAILURE, error));
        },
      },
    });

    return null;
  };
}

export function requestSuccess(actionType: string, responseJSON: object) {
  return {
    type: actionType,
    payload: responseJSON,
  };
}

export function requestFailed(actionType: string, responseJSON: object) {
  return {
    type: actionType,
    payload: responseJSON,
  };
}
